import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {projectsRouting} from './projects/projects.routing';
import {trackersRouting} from './trackers/trackers.routing';
import {rewardsRouting} from './rewards/rewards.routing';
import {TokensComponent} from './tokens/tokens.component';
import {alertsRouting} from './alerts/alerts.routing';
import {WIKI_ITEM_PATH} from './wiki/wiki.routing';
import {currentSkedRouting} from './current-sked/current-sked.routing';
import {peopleRouting} from './people/people.routing';
import {RolePermissionsGuard} from './core/guards/role-permissions.guard';
import {projectsRouteGuard} from './core/guards/projects-route.guard';
import {profileRouting} from './profile/profile.routing';
import {nativeSettingsRouting} from './native-settings/native-settings.routing';
import {ProjectsLayoutComponent} from './shared/projects/projects-layout/projects-layout.component';
import {TrackerDetailComponent} from './trackers/tracker-detail/tracker-detail.component';
import {TrackerDetailGuard} from './trackers/tracker-detail/tracker-detail.guard';
import {WikiViewArticleComponent} from './wiki/wiki-view-article/wiki-view-article.component';
import {WikiMainComponent} from './wiki/wiki-main/wiki-main.component';
import {ReportingComponent} from './reporting-new/reporting.component';

const routes: Routes = [
  {
    path: 'current-sked',
    canActivate: [RolePermissionsGuard],
    children: currentSkedRouting,
  },
  {
    path: 'goals',
    canActivate: [RolePermissionsGuard],
    loadChildren: () => import('./goals/goals.module').then(m => m.GoalsModule),
  },
  {
    path: 'skills',
    loadChildren: () => import('./skills/skills.module').then(m => m.SkillsModule),
    canActivate: [RolePermissionsGuard],
  },
  {
    path: 'programs',
    canActivate: [RolePermissionsGuard],
    loadChildren: () => import('./programs/programs.module').then(m => m.ProgramsModule),
  },
  {
    path: 'locations',
    canActivate: [RolePermissionsGuard],
    loadChildren: () => import('./locations/locations.module').then(m => m.LocationsModule),
  },
  {
    path: 'actions',
    canActivate: [RolePermissionsGuard],
    loadChildren: () => import('./actions/actions.module').then(m => m.ActionsModule),
  },
  {
    path: 'team-schedule',
    canActivate: [RolePermissionsGuard],
    loadChildren: () => import('./team-schedule/team-schedule.module').then(m => m.TeamScheduleModule),
  },
  // Detail routes that bypass the projects-layout nav shell
  {
    path: 'trackers/:id',
    canActivate: [RolePermissionsGuard],
    component: TrackerDetailComponent,
    canDeactivate: [TrackerDetailGuard],
  },
  {
    path: `wiki/${WIKI_ITEM_PATH}/:slug/:itemId`,
    canActivate: [RolePermissionsGuard],
    component: WikiViewArticleComponent,
  },
  {path: '', redirectTo: '/current-sked', pathMatch: 'full'},
  // Shared projects-layout shell — keeps projects-routing persistent across tab navigation
  {
    path: '',
    component: ProjectsLayoutComponent,
    children: [
      {
        path: 'projects',
        canActivate: [RolePermissionsGuard, projectsRouteGuard],
        children: projectsRouting,
      },
      {
        path: 'reporting-old',
        canActivate: [RolePermissionsGuard],
        loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule),
      },
      {
        path: 'reporting',
        canActivate: [RolePermissionsGuard],
        component: ReportingComponent,
      },
      {
        path: 'schedule',
        canActivate: [RolePermissionsGuard],
        loadChildren: () => import('./schedule/schedule.module').then(m => m.ScheduleModule),
      },
      {
        path: 'trackers',
        canActivate: [RolePermissionsGuard],
        children: trackersRouting,
      },
      {
        path: 'rewards',
        canActivate: [RolePermissionsGuard],
        children: rewardsRouting,
      },
      {
        path: 'tokens',
        canActivate: [RolePermissionsGuard],
        component: TokensComponent,
      },
      {
        path: 'wiki',
        canActivate: [RolePermissionsGuard],
        component: WikiMainComponent,
      },
    ],
  },
  {
    path: 'alerts',
    canActivate: [RolePermissionsGuard],
    children: alertsRouting,
  },
  {
    path: 'people',
    canActivate: [RolePermissionsGuard],
    children: peopleRouting,
  },
  {
    path: 'profile',
    children: profileRouting,
  },
  {
    path: 'native-settings',
    children: nativeSettingsRouting,
  },
  // Wildcard route
  {
    path: '**',
    redirectTo: '/current-sked',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
